import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const FirmwareVersionViewModule = new Module({
  id: 'FIRMWARE-VERSION:VIEW:RESULT-TABLE',
  name: 'Firmware Versions',
  label: 'Firmware Versions',
  path: 'firmware-version',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/FirmwareVersions/View'))
  ),
  actions: {
    edit: {
      id: 'FIRMWARE-VERSION:EDIT:*',
      name: 'edit',
      label: 'Edit'
    },
    // delete: {
    //   id: 'firmware-version-delete',
    //   name: 'delete',
    //   label: 'Delete'
    // }
  }
});

export const FirmwareVersionAddModule = new Module({
  id: 'FIRMWARE-VERSION:ADD:*',
  name: 'firmwareVersionAdd',
  path: 'firmware-version/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/FirmwareVersions/Form'))
  ),
  actions: {
    add: {
      id: 'FIRMWARE-VERSION:ADD:*',
      name: 'Firmware Version Add',
      label: 'Add Firmware Version'
    }
  }
});

export const FirmwareVersionEditModule = new Module({
  id: 'FIRMWARE-VERSION:EDIT:*',
  name: 'Firmware Version Edit',
  path: 'firmware-version/edit/:firmwareVersionId',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/FirmwareVersions/Form'))
  )
});

const FirmwareVersionModules = [
  FirmwareVersionViewModule,
  FirmwareVersionAddModule,
  FirmwareVersionEditModule
];

export default new ModuleBundle('FirmwareVersion', FirmwareVersionModules);
